import React, { Component } from 'react';
import { observer } from 'mobx-react';
import {PageHeader} from 'antd';
import { pageSectionTitle } from '../util/Style';
import { periodFromBucket } from '../util/Util';

import { AgGridReact } from 'ag-grid-react';
import InvoiceDetailsStore from '../stores/InvoiceDetailsStore';
import InvoiceDetailsSummary from './InvoiceDetailsSummary';

const height = window.innerHeight * .65;

const defaultColDef = {
    sortable: true,
    resizable: true,
    filter: true,
    flex: 1,
};

const dueGetter = (params) => {
    return params.data.BillTotal - params.data.AdvanceTotal;
};

const columnDefs = [
    { headerName: 'Type', field: 'collectionType', filter: 'agNumberColumnFilter', width: 125, headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
    { headerName: 'Bucket', field: 'bucket', filter: 'agNumberColumnFilter', width: 125, headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
    { headerName: 'Number', field: 'InvoiceNumber', width: 100 },
    { headerName: 'Bill Amount', field: 'BillTotal', type: 'numericColumn', filter: 'agNumberColumnFilter', width: 125, headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
    { headerName: 'Received Amount', field: 'AdvanceTotal', type: 'numericColumn', filter: 'agNumberColumnFilter', width: 125, headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
    { headerName: 'Due', field: 'Due', valueGetter: dueGetter, type: 'numericColumn', filter: 'agNumberColumnFilter', headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
    { headerName: 'Created Date', field: 'InvoiceDate', width: 75, type:'dateColumn' },
]

class InvoiceDetails extends Component {

    gridRef = React.createRef();

    constructor(props) {
        super(props);
        const referrerId = props.params.referrerId;
        const collectionType = props.params.collectionType;
        this.store = new InvoiceDetailsStore({apiProxy: props.appStore.apiProxy, referrerId, collectionType});
    }

    fetchInvoices = () => {
        this.store.fetchInvoices(this.props.params.collectionType);
    }

    refreshGrid = () => {
        this.gridRef.current.api.redrawRows();
    }

    onRowClicked = async() => {
        const selectedRows = this.gridRef.current.api.getSelectedRows();

        const number = selectedRows[0].InvoiceNumber;
        const bucket = selectedRows[0].bucket;
        const address = selectedRows[0].address;
        const collectionType = selectedRows[0].collectionType;
        const name = this.props.params.labName;

        const period = periodFromBucket(bucket,collectionType);
        const startDate = selectedRows[0].InvoiceDate.substr(0,10)
        const endDate = startDate;
        
        const invoiceHeader = {name,number,startDate, endDate ,address};
     
        const url = await this.store.showInvoice(invoiceHeader);

        window.open(url);
   }

   split = (patientTestMap) => {
  
        const withUnit =  [...patientTestMap];
        const withoutUnit =  [...patientTestMap];
        withUnit.reportDetails.length=0;
        withoutUnit.reportDetails.length=0;
    
        let details = patientTestMap.reportDetails;

        for(let i=0;i<details.length;i++) {
            let testOrProfile = details[i]
            if(testOrProfile.mainProfileName === "ANA ") {
                withoutUnit.reportDetails.push(testOrProfile);
            }
            else {
                withUnit.reportDetails.push(testOrProfile);
            }
        }

        return {withUnit,withoutUnit};
   }

    render() {
        const labName = this.props.params.labName;
        return (
            <PageHeader style={{ paddingTop: 0 }} title={pageSectionTitle(labName)}>
                <div className="ag-theme-alpine" style={{ height: height, width: '100%' }}>
                    <AgGridReact
                        ref={this.gridRef}
                        defaultColDef={defaultColDef}
                        rowData={this.store.invoices}
                        columnDefs={columnDefs}
                        rowSelection={'single'}
                        onRowClicked={this.onRowClicked}
                        onGridReady={this.fetchInvoices}
                        rowHeight={25}
                    >
                    </AgGridReact>
                    <div>
                        <InvoiceDetailsSummary store={this.store} />
                    </div>
                </div>
            </PageHeader>
        )
    }
}

export default observer(InvoiceDetails)
